import formatDecimal from './format-decimal';

const formatArea = (areaHa?: number | null) =>
  areaHa == null ? null : `${formatDecimal(areaHa)} ha`;

export default formatArea;
